

export default class Platform {
    constructor(t) {
        this.instance = t
    }

    getIntegrationsClient() {
        return this.instance.$integrationApi
    }

    getMediaClient() {
        return this.instance.$mediaHttp
    }

    getRatchetClient() {
        return this.instance.$ratchetApi
    }

    getPlatformClient() {
        return this.instance.$http
    }

    getWorkflowClient() {
        return this.instance.$workflowApi
    }

    getSandboxClient() {
        return this.instance.$sandbox.client.http()
    }
}